import { Trans, useTranslation } from 'react-i18next'

import Notifications from '@/components/Notifications'
import SimulateurWarning from '@/components/SimulateurWarning'
import Simulation from '@/components/Simulation'
import { YearSelectionBanner } from '@/components/Simulation/YearSelectionBanner'
import { DarkLi, Strong, Ul } from '@/design-system'
import { usePageMetadata } from '@/hooks/usePageMetadata'
import useSimulationPublicodes from '@/hooks/useSimulationPublicodes'
import { SimulateurId } from '@/hooks/useSimulatorsMetadata'
import { EngineProvider } from '@/utils/publicodes/EngineContext'

import SimulateurPageLayout from '../SimulateurPageLayout'
import { Explications } from './components/Explications'
import { DividendesSimulationGoals } from './Goals'
import { dividendesMetadata } from './metadata'
import { SeoExplanations } from './SeoExplanations'
import { configDividendes } from './simulationConfig'

const nextSteps = [
	'salarié',
	'is',
	'comparaison-statuts',
] satisfies SimulateurId[]

export default function DividendesSimulation() {
	const metadata = usePageMetadata(dividendesMetadata)
	const { isReady, engine, questions, raccourcis } = useSimulationPublicodes(
		metadata,
		configDividendes
	)

	const { t } = useTranslation()

	return (
		<EngineProvider value={engine}>
			<SimulateurPageLayout
				metadata={metadata}
				seoExplanations={<SeoExplanations />}
				isReady={isReady}
				nextSteps={nextSteps}
			>
				<Notifications />
				<Simulation
					questionsPublicodes={questions}
					raccourcisPublicodes={raccourcis}
					explanations={<Explications />}
					afterQuestionsSlot={<YearSelectionBanner />}
				>
					<SimulateurWarning
						metadata={metadata}
						informationsComplémentaires={
							<Ul>
								<DarkLi>
									<Trans i18nKey="pages.simulateurs.dividendes.warning.1">
										Cette simulation ne concerne que les sociétés françaises à
										l’impôt sur les sociétés (IS), et{' '}
										<Strong>
											ne concerne pas les travailleurs indépendants non salariés
										</Strong>{' '}
										comme les <Strong>gérants majoritaires de SARL</Strong>, les
										associés uniques d’
										<Strong>EURL</Strong> ou les{' '}
										<Strong>associés de SNC</Strong>.
									</Trans>
								</DarkLi>
								<DarkLi>
									{t(
										'pages.simulateurs.dividendes.warning.2',
										'Le montant de l’impôt sur les dividendes est calculé en plus de l’impôt sur les autres revenus imposables.'
									)}
								</DarkLi>
							</Ul>
						}
					/>
					<DividendesSimulationGoals />
				</Simulation>
			</SimulateurPageLayout>
		</EngineProvider>
	)
}
